import { Typography } from '@mui/material';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { CashierFlowType } from '../../../../../../types/Cashier';
import Prompt from '../../../../../Prompt/Prompt';

import {
  TXTCLI_Resume,
  TXTMOB_Are_you_sure_you_want_to_exitX,
  TXTWCL_Are_you_sureX,
  TXTWCL_Are_you_sure_you_want_to_exit__ELL,
  TXTWCL_Back_to_deposit_1,
  TXTWCL_Confirm_Exit,
  TXTWCL_Exit_This_Page,
  TXTWCL_Leave_anyway,
  TXTWCL_Stay_On_This_Page,
  TXTWCL_You_may_lose_your_progress_if__ELL,
  TXTWCL_Your_account_is_not_verified_y_ELL,
  TXTWCL_Your_deposit_will_be_cancelled_ELL,
  TXTWCL_Your_username_and_password_hav_ELL
} from './ExitPrompt.messages.json';

interface Props {
  title?: React.ReactNode;
  onClose: () => void;
  handleRegulatoryExitFlow(): void;
  handleExitRmfFlow(): void;
}

const ExitPrompt: React.FC<Props> = ({ onClose, handleRegulatoryExitFlow, handleExitRmfFlow }) => {
  const {
    data: { cashierFlow }
  } = useWizardContext();
  const isUK = useSelector(select.cms.getSiteId) === Sites.UK;
  const isDE = useSelector(select.cms.getSiteId) === Sites.DE;
  const { pathname } = useLocation();
  const isRmf = pathname.includes('rmf');
  const isDepositFlow = cashierFlow === CashierFlowType.FirstDeposit;
  const shouldUpdatePromptMessage = isRmf && (isDE || isUK);

  let promptTitle;
  let promptConfirmExitButton;
  let promptDismissExitButton;
  if (isDepositFlow) {
    promptTitle = isDE ? TXTWCL_Confirm_Exit : TXTWCL_Are_you_sureX;
    promptConfirmExitButton = TXTWCL_Leave_anyway;
    promptDismissExitButton = TXTWCL_Back_to_deposit_1;
  } else if (shouldUpdatePromptMessage) {
    promptTitle = isDE ? TXTWCL_Confirm_Exit : TXTWCL_Are_you_sureX;
    promptConfirmExitButton = isDE ? TXTWCL_Exit_This_Page : TXTWCL_Confirm_Exit;
    promptDismissExitButton = isDE ? TXTWCL_Stay_On_This_Page : TXTCLI_Resume;
  } else {
    promptTitle = TXTWCL_Confirm_Exit;
    promptConfirmExitButton = TXTWCL_Exit_This_Page;
    promptDismissExitButton = TXTWCL_Stay_On_This_Page;
  }
  return (
    <>
      {
        <Prompt
          variant="info"
          title={{
            translation: promptTitle
          }}
          primaryButton={{
            translation: promptDismissExitButton
          }}
          secondaryButton={{
            translation: promptConfirmExitButton
          }}
          onPrimaryButtonClick={onClose}
          onSecondaryButtonClick={
            (isUK || isDE) && isRmf ? handleRegulatoryExitFlow : handleExitRmfFlow
          }
          onClose={onClose}
          isExitPrompt
        >
          <Typography>
            {isDepositFlow ? (
              <Translation {...TXTWCL_Your_deposit_will_be_cancelled_ELL} />
            ) : shouldUpdatePromptMessage ? (
              isDE ? (
                <>
                  <Translation {...TXTWCL_Are_you_sure_you_want_to_exit__ELL} />
                  <br />
                  <Translation {...TXTWCL_Your_username_and_password_hav_ELL} />
                </>
              ) : (
                <Translation {...TXTWCL_Your_account_is_not_verified_y_ELL} />
              )
            ) : (
              <>
                <Translation {...TXTWCL_You_may_lose_your_progress_if__ELL} />
                <br />
                <Translation {...TXTMOB_Are_you_sure_you_want_to_exitX} />
              </>
            )}
          </Typography>
        </Prompt>
      }
    </>
  );
};
export default ExitPrompt;
